/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import BundleAction from "../action/BundleAction";

export const initialState = ({
    loading: false,
    bundleList: null, 
    bundle: null,   
})

export default function (state = initialState, action) {
    switch (action.type) {
  
      case BundleAction.TYPES.REQUEST_BUNDLE_LIST:
        return Object.assign({}, state, { bundleList: null, loading: true})
  
      case BundleAction.TYPES.REQUEST_BUNDLE_LIST_SUCCESS:
        return Object.assign({}, state, { bundleList: action.payload, loading: false})

      case BundleAction.TYPES.REQUEST_UPDATE_BUNDLE_STATUS_SUCCESS: {

        const newList = state.bundleList
        if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});
        newList.data = newList.data.map(item => {
          if(item.id == action.payload.data.id) {
            action.payload.data.itemCount = item.itemCount
            return action.payload.data
          }
          return item
        })
        
        return Object.assign({}, state, { bundleList: newList, loading: false})
      }
      case BundleAction.TYPES.REQUEST_CREATE_BUNDLER_SUCCESS: {
          const newList = state.bundleList      
          if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});        
          newList.data = [action.payload.data, ...newList.data]
          return Object.assign({}, state, { bundleList: newList, loading: false})
      }  
              
      default:
        return state
    }
}



  